import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageSuccessOptions, NotifyUserService } from '@shared/notify-user.service';

@Component({
    selector: 'app-success-modal',
    templateUrl: './success-modal.component.html',
    styleUrls: ['./success-modal.component.scss'],
})
export class SuccessModalComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: MessageSuccessOptions, public dialogRef: MatDialogRef<SuccessModalComponent>) {}

    ngOnInit(): void {}
}
